import _ from 'lodash';

class Table {
    constructor (data, options) {
        this.options = options;
        this._init(data);

        _.forEach(this.data, (value, i) => {
            if (this.options.value) {
                const column = value[this.options.column] || this.options.column || this.options.value;
                const row = value[this.options.row] || this.options.row || this.options.value;
                value = value[this.options.value];
                return this._setData(column, row, value);
            } else {
                if (_.isArray(this.options.row)) {
                    return _.forEach(this.options.row, row => {
                        return this._setData(value[this.options.column], row, value[row]);
                    });
                } else if (_.isArray(this.options.column)) {
                    return _.forEach(this.options.column, column => {
                        return this._setData(column, value[this.options.row], value[column]);
                    });
                }
            }
        });

        delete this.options;
    }

    _init (data) {
        this.columns = [];
        this.rows = [];
        this.body = {};
        this.total = 0;
        this.totalRows = {};
        this.totalColumns = {};
        this.data = data;
    }

    _setData (col, row, val) {
        col = String(col);
        row = String(row);

        if (!_.isArray(this.options.exclude)) {
            this.options.exclude = [this.options.exclude];
        }

        if (this.options.exclude.contains(row)) {
            return;
        }

        // row = "others" if options.others and Object.keys(rows).length > options.others
        if (!this.body[col]) { this.body[col] = {}; }

        if (!this.totalRows[row]) { this.totalRows[row] = 0; }

        if (!this.totalColumns[col]) { this.totalColumns[col] = 0; }

        if (_.isNumber(val)) {
            this.totalRows[row] += val;
            this.totalColumns[col] += val;
            this.total += val;
        }

        this.body[col][row] = val;

        if (this.options.header) {
            if (!this.columns.contains(this.options.header(col))) {
                this.columns.push(this.options.header(col));
            }
        } else {
            if (!this.columns.contains(col)) {
                this.columns.push(col);
            }
        }

        if (!this.rows.contains(row)) {
            return this.rows.push(row);
        }
    }
}

export default Table;



// WEBPACK FOOTER //
// ./src/scripts/core/charts/Table.js